module.exports = __webpack_public_path__ + "static/media/play-boss-lose-3.2e10c182.png";